import React from 'react';
import ToastSushi from "sushiweb/Toast";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { useState } from 'react';
import { useEffect } from 'react';
import {
    resetToastMessage
  } from "../../../../src/redux/dispatchers/toastDispatcher";

const Toast = (props) => {
    const [showToast, setShowToast ] = useState(false);
    const  toastCloseHandler = () => {
        setShowToast(false);
        props.actions.resetToastMessage();
    }
    useEffect(()=>{
        if (Object.keys(props.toastMessage)?.length) {
            setShowToast(true);
        }

    },[props.toastMessage])

   return <ToastSushi 
   show={showToast}
   align="bottom"
   onClose={toastCloseHandler}
   text={props.toastMessage?.message}
   type={props.toastMessage?.type}
   autoHideDuration = {2}
   {...props}></ToastSushi>
}

export default withRouter(
    connect(
      (state) => ({
        toastMessage: state.toast || {},
      }),
      (dispatch) => ({
        actions: bindActionCreators(
          {resetToastMessage},
          dispatch
        ),
      })
    )(Toast)
  );